'use es6';

import Raven from 'raven-js';
export default (() => next => action => {
  if (action.error) {
    const {
      payload,
      type
    } = action;
    const extra = {};

    try {
      // add request info
      if (payload.options && payload.options.data) {
        extra.requestParams = JSON.parse(payload.options.data);
      } // add response info


      if (payload.responseJSON) {
        extra.response = payload.responseJSON;
      } else if (payload.data) {
        extra.response = JSON.parse(payload.data);
      }
    } catch (exc) {
      // nothing else we can do here
      extra.jsonParsingException = exc;
    } // Handle incremental move to serialized errors


    let message = payload;

    if (payload.isSerializedError) {
      message = payload.message;
      Object.assign(extra, payload);
    }

    Raven.captureException(message, {
      logger: 'redux middleware',
      tags: {
        reportingActionType: type
      },
      fingerprint: [type, payload.status],
      extra
    });
  }

  return next(action);
});